/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S5_BodyInputs */

const en_landing_guide_s5_body = /** @type {(inputs: Landing_Guide_S5_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 3.0 and Ideogram 4.0 made big steps in typography, layout and image quality. Version 4.5 keeps those strengths and targets the step after generation. In Ideogram's published comparisons it stays clean across repeated edits where other models degrade, and Ideogram demonstrated it editing a 24.2-megapixel source at 4016 × 6016 without downsizing. Open weights have been announced but were not released at launch. If your work is mostly one-shot generation, any recent model will do. If it involves revisions, this release is the one to pick.`)
};

const zh_landing_guide_s5_body = /** @type {(inputs: Landing_Guide_S5_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 3.0 和 Ideogram 4.0 在文字排版、版式和画质上都有长足进步。Ideogram 4.5 保留了这些优势，并把重点放在生成之后的那一步。在 Ideogram 公布的对比中，其他模型反复编辑后画质下降，而 4.5 始终保持干净；Ideogram 还演示了在不缩小的情况下编辑一张 4016 × 6016（2420 万像素）的源图。开放权重已宣布，但发布时尚未公开。如果你的工作以一次性生成为主，近期的模型都够用；如果需要反复修改，Ideogram AI 4.5 是更好的选择。`)
};

/**
* | output |
* | --- |
* | "Ideogram 3.0 and Ideogram 4.0 made big steps in typography, layout and image quality. Version 4.5 keeps those strengths and targets the step after generation..." |
*
* @param {Landing_Guide_S5_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s5_body = /** @type {((inputs?: Landing_Guide_S5_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S5_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s5_body(inputs)
	return zh_landing_guide_s5_body(inputs)
});
export { landing_guide_s5_body as "landing.guide.s5_body" }